// console.info("执行index.js", new Date());
//增加全局对象 StarSoft 用于存储全局参数对象  add by chenk 2019.01.03
if (typeof StarSoft == "undefined") {
    window.StarSoft = { Load: {} };
}

StarSoft.noAlertPage = "#/,#/login,";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
let allData = require("../../GlobalParam.json");

StarSoft.isInitUI = false; //是否完成初始UI或已经打开过页面 add by chenk 2019.01.09
StarSoft.isLogin = false; //是否已登录  add by chenk 2019.01.16

StarSoft.Enum = {
    isInitSys: "isInitSys"
};
StarSoft.LoginKey = localStorage.getItem("loginKey");
StarSoft.V8LoginKey = localStorage.getItem("V8LoginKey");

/*保存路由信息*/
var routesData = [
    {
        path: "/",
        redirect: "/emptyPage"
    },
    {
        path: "/",
        component: () =>
            import(/* webpackChunkName: "Home" */ "../components/common/Home.vue"),
        children: [
            {
                path: "/UserCenter_1218",
                name: 'UserCenter_1218',
                component: () =>
                    import(/* webpackChunkName: "Notice" */ "../components/page/UserCenter.vue"),
                meta: { title: "用户中心", permission: false }
            },
            {
                path: "/emptyPage",
                component: () =>
                    import(/* webpackChunkName: "emptyPage" */ "../components/page/emptyPage.vue"),
                meta: { title: "空白页" }
            },
            {
                path: "/timeOut",
                component: () =>
                    import(/* webpackChunkName: "timeOut" */ "../components/page/timeOut.vue"),
                meta: { title: "登录超时" }
            },
            // {
            //     path: "/kanban",
            //     component: () =>
            //         import(/* webpackChunkName: "timeOut" */ "../components/page/BoardMgr/BoardInterface2.vue"),
            //     meta: {
            //         title: "看板",
            //         url: "http://192.168.40.103:9015/Web/api/BoardMgr/BoardSet"
            //     }
            // },
            {
                path: "/ApplyToCompany_11111111",
                component: () =>
                    import(/* webpackChunkName: "ApplyToCompany" */ "../components/page/emptyPage.vue"),
                meta: {
                    title: "创建团队",
                    HasPage: true,
                    src:
                        allData.HttpMainUrl +
                        "UserLoginMgr/Ulogin/ApplyToCompany",
                    RightId: 11111111,
                    ParentID: 11111111,
                    TopParentID: 11111111,
                    keepAlive: false,
                    isIframe: true,
                    zIndex: 2,
                    MenuType: "",
                    url: allData.HttpMainUrl,
                    tabId: "ApplyToCompany_11111111",
                    Query: ""
                }
            },
            {
                // 没有权限
                path: "/NoPower",
                component: () =>
                    import(/* webpackChunkName: "NoMenuPower" */ "../components/page/NoMenuPower.vue"),
                meta: { title: "没有权限", permission: false }
            },
            {
                // 权限页面
                path: "/permission",
                component: () =>
                    import(/* webpackChunkName: "Permission" */ "../components/page/Permission.vue"),
                meta: { title: "权限测试", permission: true }
            },
            // {
            //     // 权限页面
            //     path: "/diaodu",
            //     component: () =>
            //         import(/* webpackChunkName: "Permission" */ "../components/page/diaodu.vue"),
            //     meta: { title: "生产调度", permission: false }
            // },
            // {
            //     // 权限页面
            //     path: "/shajiang",
            //     component: () =>
            //         import(/* webpackChunkName: "shajiang" */ "../components/page/shajiang.vue"),
            //     meta: { title: "砂浆罐", permission: false }
            // },
            {
                path: "/404",
                component: () =>
                    import(/* webpackChunkName: "404" */ "../components/page/404.vue"),
                meta: { title: "404" }
            },
            {
                path: "/403",
                component: () =>
                    import(/* webpackChunkName: "403" */ "../components/page/403.vue"),
                meta: { title: "403" }
            },
            {
                path: "/loading",
                component: () =>
                    import(/* webpackChunkName: "loading" */ "../components/common/SkipPage.vue"),
                meta: { title: "loading" }
            }
        ]
    },
    {
        path: "/StirPage",
        component: () =>
            import(/* webpackChunkName: "StirPage" */ "../components/page/StirPage.vue"),
        meta: { title: "详情页", permission: false }
    },
    {
        path: "/DriverFreight",
        component: () =>
            import(/* webpackChunkName: "DriverFreight" */ "../components/page/DriverFreight.vue"),
        meta: { title: "司机运费", permission: false }
    },
    {
        path: "/Notice/:id",
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/Notice.vue"),
        meta: { title: "通知详情", permission: false }
    },
    {
        path: "/FrontServiceConfig",
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/FrontService/FrontServiceConfig.vue"),
        meta: { title: "前置机ID分配", permission: false }
    },
    {
        path: "/FrontServiceMgr",
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/FrontService/FrontServiceMgr.vue"),
        meta: { title: "前置机服务管理", permission: false }
    },
    {
        path: "/ShowClientWeb",
        name: 'ShowClientWeb',
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/ShowClientWeb.vue"),
        meta: { title: "跳转", permission: false }
    },
    {
        path: "/LookEvidence",
        name: 'LookEvidence',
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/LookEvidence.vue"),
        meta: { title: "ADAS报警信息", permission: false }
    },
    {
        path: "/repair",
        name: 'repair',
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/repair.vue"),
        meta: { title: "车辆报修", permission: false }
    },
    {
        path: "/carInfo",
        name: 'carInfo',
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/carInfo.vue"),
        meta: { title: "车辆详情", permission: false }
    },
    {
        path: "/LED",
        component: () =>
            import(/* webpackChunkName: "Notice" */ "../components/page/QueueMgr/LedConfig.vue"),
        meta: {
            title: "LED屏显示配置",
            src: "/Web/QueueMgr/LedConfig",
            RightUrl: "QueueMgr/LedConfig",
            RightId: 94041102,
            ParentID: 94041100,
            TopParentID: 94000000,
            HasPage: true,
            keepAlive: false,
            isIframe: false,
            IsNotifyClient: 100,
            zIndex: 4,
            url: "/Web/api/QueueMgr/LedConfig",
            // url: "http://192.168.40.103:9015/Web/api/QueueMgr/LedConfig",
            TargetUrl: "api/QueueMgr/LedConfig",
            UrlPrefix: "/Web/",
            tabId: "XTGL_SYSSET_QUEUE_JMPZ_94041102",
            permission: false
        }
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import(/* webpackChunkName: "Login" */ "../components/page/Login.vue")
    },
    {
        path: "*",
        redirect: "/404"
    }
];

//固定菜单长度
StarSoft.MenuBaseLen = routesData[1].children.length;

var RouterData = (StarSoft.Router = new Router({
    routes: routesData
}));

//console.log('返回路由对象：',routesData);
export default RouterData;
